import axios from "axios";
import { getDataFromStorage } from '../../views/System/emitter';

function getHttpClient() {
  const userId = getDataFromStorage().userId;
  if (userId) {
    return axios.create({
      baseURL: process.env.VUE_APP_FIREFLY_API_URL,
      headers: {
        "UserId-Imp": getDataFromStorage().userId,
        "Content-Type": "application/json",
        "Authorization": "Bearer " + sessionStorage.getItem('accessToken'),
      },
    });
  }
  else {
    return axios.create({
      baseURL: process.env.VUE_APP_FIREFLY_API_URL,
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + sessionStorage.getItem('accessToken'),
      },
    });
  }
}

function getInfo(
  requestUrl,
  requestParameter,
  requestData,
  context,
  successHandlerName,
  errorHandlerName,
  token
) {
  return new Promise((resolve, reject) => {
    getHttpClient(token)
      .get(requestUrl)
      .then((response) => {
        onSuccess(
          response,
          requestData,
          requestParameter,
          context,
          successHandlerName,
          resolve
        );
      })
      .catch(function (error) {
        onError(
          error,
          requestData,
          requestParameter,
          context,
          errorHandlerName,
          reject
        );
      });
  });
}

function postInfo(
  requestUrl,
  requestParameter,
  requestData,
  context,
  successHandlerName,
  errorHandlerName, token
) {
  return new Promise((resolve, reject) => {
    getHttpClient(token)
      .post(requestUrl, requestData)
      .then((response) => {
        onSuccess(
          response,
          requestData,
          requestParameter,
          context,
          successHandlerName,
          resolve
        );
      })
      .catch((error) => {
        console.log("error trigered");
        console.log(error.message);
        onError(
          error,
          requestData,
          requestParameter,
          context,
          errorHandlerName,
          reject
        );
      });
  });
}

function putInfo(
  requestUrl,
  requestParameter,
  requestData,
  context,
  successHandlerName,
  errorHandlerName, token
) {
  return new Promise((resolve, reject) => {
    getHttpClient(token)
      .put(requestUrl, requestData)
      .then((response) => {
        onSuccess(
          response,
          requestData,
          requestParameter,
          context,
          successHandlerName,
          resolve
        );
      })
      .catch(function (error) {
        onError(
          error,
          requestData,
          requestParameter,
          context,
          errorHandlerName,
          reject
        );
      });
  });
}

function patchInfo(
  requestUrl,
  requestParameter,
  requestData,
  context,
  successHandlerName,
  errorHandlerName, token
) {
  return new Promise((resolve, reject) => {
    getHttpClient(token)
      .patch(requestUrl, requestData)
      .then((response) => {
        onSuccess(
          response,
          requestData,
          requestParameter,
          context,
          successHandlerName,
          resolve
        );
      })
      .catch(function (error) {
        onError(
          error,
          requestData,
          requestParameter,
          context,
          errorHandlerName,
          reject
        );
      });
  });
}

function deleteInfo(
  requestUrl,
  requestParameter,
  requestData,
  context,
  successHandlerName,
  errorHandlerName, token
) {
  return new Promise((resolve, reject) => {
    getHttpClient(token)
      .delete(requestUrl)
      .then((response) => {
        onSuccess(
          response,
          requestData,
          requestParameter,
          context,
          successHandlerName,
          resolve
        );
      })
      .catch(function (error) {
        onError(
          error,
          requestData,
          requestParameter,
          context,
          errorHandlerName,
          reject
        );
      });
  });
}

function onSuccess(
  response,
  requestData,
  requestParameter,
  context,
  commitMethodName,
  resolve
) {
  let data = {
    server: response,
    requestData: requestData,
    parameter: requestParameter,
  };
  if (context) {
    if (commitMethodName) context.commit(commitMethodName, data);
  }
  resolve(data);
}
function onError(
  errorResponse,
  requestData,
  requestParameter,
  context,
  commitMethodName,
  reject
) {
  let data = {
    server: errorResponse,
    requestData: requestData,
    parameter: requestParameter,
  };
  if (
    errorResponse &&
    errorResponse.response &&
    errorResponse.response.status === 401 &&
    context
  ) {
    console.log(errorResponse.response);
  }
  if (commitMethodName) {
    context.commit(commitMethodName, data);
  }
  reject(data);
}
export default {
  getInfo,
  postInfo,
  putInfo,
  patchInfo,
  deleteInfo,
};